import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import '../css/style.css';
import '../components/Home.css';
import EventPagingLayout from './EventPagingLayout';
import { translate } from "react-i18next";
import {  Row, Col } from 'react-bootstrap';

class TemplatesLayout extends Component {

  
    render() {
        const { t } = this.props;
        const { params } = this.props.match
        return (<SimpleLayout title={t("myEvents")} eventKey="3">
            <div>
                <Row className="mt-2">
                    <Col >
                        <h5>TemporaireXXX</h5>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col >
                    <EventPagingLayout preURL="events/userTemplate" id={params.id} edit={true}  />
                    </Col>
                </Row>
                
              
                
            </div>
        </SimpleLayout>)
    }

}

export default translate("translations")(TemplatesLayout);